// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__B2hgV","selected":"FAQ_selected__Q6rOH","big":"FAQ_big__POgKL","responseText2":"FAQ_responseText2__YjggE","response-div":"FAQ_response-div__xUaaW"};